export default __webpack_public_path__ + "static/qlab-5-icon-1c477fc6fa7937ec57b19bd79b7a815b.png";